export default __webpack_public_path__ + "static/media/img-21.76e2e86c.jpg";